import { __extends } from "tslib";
import { delegateCombine, delegateRemove } from "igniteui-react-core";
import { IgrSeries } from "./igr-series";
import { IgrCalloutPlacementPositionsCollection } from "./igr-callout-placement-positions-collection";
import { AutoCalloutVisibilityMode_$type } from "./AutoCalloutVisibilityMode";
import { CalloutCollisionMode_$type } from "./CalloutCollisionMode";
import { IgrCalloutStyleUpdatingEventArgs } from "./igr-callout-style-updating-event-args";
import { IgrCalloutRenderStyleUpdatingEventArgs } from "./igr-callout-render-style-updating-event-args";
import { IgrCalloutContentUpdatingEventArgs } from "./igr-callout-content-updating-event-args";
import { IgrCalloutLabelUpdatingEventArgs } from "./igr-callout-label-updating-event-args";
import { IgrCalloutSeriesSelectingEventArgs } from "./igr-callout-series-selecting-event-args";
import { IgrAnnotationLayer } from "./igr-annotation-layer";
import { CalloutLayer } from "./CalloutLayer";
import { ensureBool, ensureEnum, brushToString, stringToBrush } from "igniteui-react-core";
import { CalloutPlacementPositionsCollection as CalloutPlacementPositionsCollection_internal } from "./CalloutPlacementPositionsCollection";
import { CalloutPlacementPositions_$type } from "./CalloutPlacementPositions";
import { SyncableObservableCollection$1 } from "igniteui-react-core";
/**
 * Represents an annotation layer that displays crosshair lines that cross through the closest value of the target series under the cursor.
*/
var IgrCalloutLayer = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrCalloutLayer, _super);
    function IgrCalloutLayer(props) {
        var _this = _super.call(this, props) || this;
        _this._allowedPositions = null;
        _this._calloutStyleUpdating = null;
        _this._calloutStyleUpdating_wrapped = null;
        _this._calloutRenderStyleUpdating = null;
        _this._calloutRenderStyleUpdating_wrapped = null;
        _this._calloutContentUpdating = null;
        _this._calloutContentUpdating_wrapped = null;
        _this._calloutLabelUpdating = null;
        _this._calloutLabelUpdating_wrapped = null;
        _this._calloutSeriesSelecting = null;
        _this._calloutSeriesSelecting_wrapped = null;
        return _this;
    }
    IgrCalloutLayer.prototype.createImplementation = function () {
        return new CalloutLayer();
    };
    Object.defineProperty(IgrCalloutLayer.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "isAnnotationCalloutLayer", {
        /**
         * Gets whether the series is an callout annotation layer.
        */
        get: function () {
            return this.i.c9;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "labelMemberPath", {
        /**
         * Gets or sets the label mapping property for the callouts.
        */
        get: function () {
            return this.i.v1;
        },
        set: function (v) {
            this.i.v1 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "xMemberPath", {
        /**
         * Gets or sets the label mapping property for the callouts.
        */
        get: function () {
            return this.i.wc;
        },
        set: function (v) {
            this.i.wc = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "yMemberPath", {
        /**
         * Gets or sets the label mapping property for the callouts.
        */
        get: function () {
            return this.i.wf;
        },
        set: function (v) {
            this.i.wf = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "keyMemberPath", {
        /**
         * Gets or sets the key mapping property for the callouts.
        */
        get: function () {
            return this.i.vy;
        },
        set: function (v) {
            this.i.vy = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "isCalloutOffsettingEnabled", {
        /**
         * Gets or sets whether to allow the callouts to be variable distances from the target points, for suppporting collision modes.
        */
        get: function () {
            return this.i.uf;
        },
        set: function (v) {
            this.i.uf = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "contentMemberPath", {
        /**
         * Gets or sets the content mapping property for the callouts.
        */
        get: function () {
            return this.i.vr;
        },
        set: function (v) {
            this.i.vr = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "targetSeriesName", {
        /**
         * Gets or sets the name of the series series to target this annotation to. If null, this annotation targets all series simultaneously.
        */
        get: function () {
            return this.i.v3;
        },
        set: function (v) {
            this.i.v3 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "targetSeries", {
        /**
         * Gets or sets the series to target this annotation to. If null, this annotation targets all series simultaneously.
        */
        get: function () {
            var r = this.i.tq;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = IgrSeries._createFromInternal(r);
                if (e) {
                    e._implementation = r;
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        set: function (v) {
            if (v != null && this._stylingContainer && v._styling)
                v._styling(this._stylingContainer, this, this);
            v == null ? this.i.tq = null : this.i.tq = v.i;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "collisionChannel", {
        /**
         * Gets or sets a channel name to identify other callout layers within the chart to share collision information with.
        */
        get: function () {
            return this.i.vo;
        },
        set: function (v) {
            this.i.vo = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "allowedPositions", {
        /**
         * Gets or sets the allowed positions that the callout layer is allowed to use.
        */
        get: function () {
            if (this._allowedPositions === null) {
                var coll = new IgrCalloutPlacementPositionsCollection();
                var innerColl = this.i.tm;
                if (!innerColl) {
                    innerColl = new CalloutPlacementPositionsCollection_internal();
                }
                this._allowedPositions = coll._fromInner(innerColl);
                this.i.tm = innerColl;
            }
            return this._allowedPositions;
        },
        set: function (v) {
            if (this._allowedPositions !== null) {
                this._allowedPositions._setSyncTarget(null);
                this._allowedPositions = null;
            }
            var coll = new IgrCalloutPlacementPositionsCollection();
            this._allowedPositions = coll._fromOuter(v);
            var syncColl = new SyncableObservableCollection$1(CalloutPlacementPositions_$type);
            var innerColl = this.i.tm;
            if (!innerColl) {
                innerColl = new CalloutPlacementPositionsCollection_internal();
            }
            syncColl._inner = innerColl;
            syncColl.clear();
            this._allowedPositions._setSyncTarget(syncColl);
            this.i.tm = innerColl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "isAutoCalloutBehaviorEnabled", {
        /**
         * Gets or sets how to select the final value to annotate.
        */
        get: function () {
            return this.i.ue;
        },
        set: function (v) {
            this.i.ue = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "useInterpolatedValueForAutoCalloutLabels", {
        /**
         * Gets or sets whether to use values, rather than labels for auto callout labels.
        */
        get: function () {
            return this.i.ui;
        },
        set: function (v) {
            this.i.ui = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "useSeriesColorForOutline", {
        /**
         * Gets or sets whether to the series color as the outline of the callout.
        */
        get: function () {
            return this.i.uj;
        },
        set: function (v) {
            this.i.uj = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "useValueForAutoCalloutLabels", {
        /**
         * Gets or sets whether to use values, rather than labels for auto callout labels.
        */
        get: function () {
            return this.i.uk;
        },
        set: function (v) {
            this.i.uk = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "autoCalloutVisibilityMode", {
        /**
         * Gets or sets the rules for when the callouts should be visible.
        */
        get: function () {
            return this.i.tf;
        },
        set: function (v) {
            this.i.tf = ensureEnum(AutoCalloutVisibilityMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutCornerRadius", {
        /**
         * Gets or sets the corner radius to use for the callout borders.
        */
        get: function () {
            return this.i.uu;
        },
        set: function (v) {
            this.i.uu = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "isCustomCalloutStyleEnabled", {
        /**
         * Gets or sets whether to allow for custom callout styles.
        */
        get: function () {
            return this.i.uh;
        },
        set: function (v) {
            this.i.uh = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "isCustomCalloutRenderStyleEnabled", {
        /**
         * Gets or sets whether to allow for custom callout styles.
        */
        get: function () {
            return this.i.ug;
        },
        set: function (v) {
            this.i.ug = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "autoCalloutLabelPrecision", {
        /**
         * Gets or sets the precision to use when values are used for the auto callout labels.
        */
        get: function () {
            return this.i.u3;
        },
        set: function (v) {
            this.i.u3 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutTextColor", {
        /**
         * Gets or sets the color to use for the callout text. Leave unset for an automatic value.
        */
        get: function () {
            return brushToString(this.i.xv);
        },
        set: function (v) {
            this.i.xv = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutBackground", {
        /**
         * Gets or sets the brush that specifies how the backgrounds for the callouts of the layer are painted. Leave unset for an automatic value.
        */
        get: function () {
            return brushToString(this.i.xs);
        },
        set: function (v) {
            this.i.xs = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutInterpolatedValuePrecision", {
        /**
         * Gets or sets the precision to use displaying values for interpolated crosshair positions.
        */
        get: function () {
            return this.i.u4;
        },
        set: function (v) {
            this.i.u4 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutOutline", {
        /**
         * Gets or sets the brush that specifies how the outlines for the callouts of the layer are painted.
        */
        get: function () {
            return brushToString(this.i.xu);
        },
        set: function (v) {
            this.i.xu = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutLeaderBrush", {
        /**
         * Gets or sets the brush that specifies how the leader lines for the callouts of the layer are painted.
        */
        get: function () {
            return brushToString(this.i.xt);
        },
        set: function (v) {
            this.i.xt = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutPaddingLeft", {
        /**
         * Gets or sets the left padding to use withing the callout. Leaving this NaN will use an automatic value related to the axis label margins.
        */
        get: function () {
            return this.i.uw;
        },
        set: function (v) {
            this.i.uw = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutPaddingTop", {
        /**
         * Gets or sets the top padding to use within the callout. Leaving this NaN will use an automatic value related to the axis label margins.
        */
        get: function () {
            return this.i.uy;
        },
        set: function (v) {
            this.i.uy = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutPaddingRight", {
        /**
         * Gets or sets the right padding to use within the callout. Leaving this NaN will use an automatic value related to the axis label margins.
        */
        get: function () {
            return this.i.ux;
        },
        set: function (v) {
            this.i.ux = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutPaddingBottom", {
        /**
         * Gets or sets the bottom padding to use within the callout. Leaving this NaN will use an automatic value related to the axis label margins.
        */
        get: function () {
            return this.i.uv;
        },
        set: function (v) {
            this.i.uv = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutCollisionMode", {
        /**
         * Gets or sets the strategy to use for avoiding collisions between the callouts in this layer. Leave unset for an automatic value.
        */
        get: function () {
            return this.i.th;
        },
        set: function (v) {
            this.i.th = ensureEnum(CalloutCollisionMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutPositionPadding", {
        /**
         * Gets or sets the padding to add to the callout positioning. Leave unset for an automatic value.
        */
        get: function () {
            return this.i.uz;
        },
        set: function (v) {
            this.i.uz = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutStrokeThickness", {
        /**
         * Gets or sets the stroke thickness for the callout backing. Leave unset for an automatic value.
        */
        get: function () {
            return this.i.u0;
        },
        set: function (v) {
            this.i.u0 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "textStyle", {
        /**
         * Gets or sets the stroke thickness for the axis annotation backing. Leave unset for an automatic value.
        */
        get: function () {
            return this.i.v6;
        },
        set: function (v) {
            this.i.v6 = v;
        },
        enumerable: false,
        configurable: true
    });
    IgrCalloutLayer.prototype.findByName = function (name) {
        var baseResult = _super.prototype.findByName.call(this, name);
        if (baseResult) {
            return baseResult;
        }
        if (this.targetSeries && this.targetSeries.name && this.targetSeries.name == name) {
            return this.targetSeries;
        }
        if (this.allowedPositions != null && this.allowedPositions.findByName && this.allowedPositions.findByName(name)) {
            return this.allowedPositions.findByName(name);
        }
        return null;
    };
    IgrCalloutLayer.prototype._styling = function (container, component, parent) {
        _super.prototype._styling.call(this, container, component, parent);
        this._inStyling = true;
        if (this.targetSeries && this.targetSeries._styling) {
            this.targetSeries._styling(container, component, this);
        }
        this._inStyling = false;
    };
    IgrCalloutLayer.prototype.getItemValue = function (item, memberPathName) {
        var iv = this.i.h1(item, memberPathName);
        return (iv);
    };
    /**
     * Invalidates content of callout layer
    
    */
    IgrCalloutLayer.prototype.invalidateCalloutContent = function () {
        this.i.wp();
    };
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutStyleUpdating", {
        /**
         * Event raised when updating style of callout layer
        */
        get: function () {
            return this._calloutStyleUpdating;
        },
        set: function (ev) {
            var _this = this;
            if (this._calloutStyleUpdating_wrapped !== null) {
                this.i.calloutStyleUpdating = delegateRemove(this.i.calloutStyleUpdating, this._calloutStyleUpdating_wrapped);
                this._calloutStyleUpdating_wrapped = null;
                this._calloutStyleUpdating = null;
            }
            this._calloutStyleUpdating = ev;
            this._calloutStyleUpdating_wrapped = function (o, e) {
                var outerArgs = new IgrCalloutStyleUpdatingEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeCalloutStyleUpdating) {
                    _this.beforeCalloutStyleUpdating(_this, outerArgs);
                }
                if (_this._calloutStyleUpdating) {
                    _this._calloutStyleUpdating(_this, outerArgs);
                }
            };
            this.i.calloutStyleUpdating = delegateCombine(this.i.calloutStyleUpdating, this._calloutStyleUpdating_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutRenderStyleUpdating", {
        /**
         * Event raised when updating style of callout layer
        */
        get: function () {
            return this._calloutRenderStyleUpdating;
        },
        set: function (ev) {
            var _this = this;
            if (this._calloutRenderStyleUpdating_wrapped !== null) {
                this.i.calloutRenderStyleUpdating = delegateRemove(this.i.calloutRenderStyleUpdating, this._calloutRenderStyleUpdating_wrapped);
                this._calloutRenderStyleUpdating_wrapped = null;
                this._calloutRenderStyleUpdating = null;
            }
            this._calloutRenderStyleUpdating = ev;
            this._calloutRenderStyleUpdating_wrapped = function (o, e) {
                var outerArgs = new IgrCalloutRenderStyleUpdatingEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeCalloutRenderStyleUpdating) {
                    _this.beforeCalloutRenderStyleUpdating(_this, outerArgs);
                }
                if (_this._calloutRenderStyleUpdating) {
                    _this._calloutRenderStyleUpdating(_this, outerArgs);
                }
            };
            this.i.calloutRenderStyleUpdating = delegateCombine(this.i.calloutRenderStyleUpdating, this._calloutRenderStyleUpdating_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutContentUpdating", {
        /**
         * Raised to allow you to decide on the content for an automatically created callout.
        */
        get: function () {
            return this._calloutContentUpdating;
        },
        set: function (ev) {
            var _this = this;
            if (this._calloutContentUpdating_wrapped !== null) {
                this.i.calloutContentUpdating = delegateRemove(this.i.calloutContentUpdating, this._calloutContentUpdating_wrapped);
                this._calloutContentUpdating_wrapped = null;
                this._calloutContentUpdating = null;
            }
            this._calloutContentUpdating = ev;
            this._calloutContentUpdating_wrapped = function (o, e) {
                var outerArgs = new IgrCalloutContentUpdatingEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeCalloutContentUpdating) {
                    _this.beforeCalloutContentUpdating(_this, outerArgs);
                }
                if (_this._calloutContentUpdating) {
                    _this._calloutContentUpdating(_this, outerArgs);
                }
            };
            this.i.calloutContentUpdating = delegateCombine(this.i.calloutContentUpdating, this._calloutContentUpdating_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutLabelUpdating", {
        /**
         * Raised to allow you to decide on the label for an automatically created callout.
        */
        get: function () {
            return this._calloutLabelUpdating;
        },
        set: function (ev) {
            var _this = this;
            if (this._calloutLabelUpdating_wrapped !== null) {
                this.i.calloutLabelUpdating = delegateRemove(this.i.calloutLabelUpdating, this._calloutLabelUpdating_wrapped);
                this._calloutLabelUpdating_wrapped = null;
                this._calloutLabelUpdating = null;
            }
            this._calloutLabelUpdating = ev;
            this._calloutLabelUpdating_wrapped = function (o, e) {
                var outerArgs = new IgrCalloutLabelUpdatingEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeCalloutLabelUpdating) {
                    _this.beforeCalloutLabelUpdating(_this, outerArgs);
                }
                if (_this._calloutLabelUpdating) {
                    _this._calloutLabelUpdating(_this, outerArgs);
                }
            };
            this.i.calloutLabelUpdating = delegateCombine(this.i.calloutLabelUpdating, this._calloutLabelUpdating_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutLayer.prototype, "calloutSeriesSelecting", {
        /**
         * Raised to allow you to select a target series for a data bound callout.
        */
        get: function () {
            return this._calloutSeriesSelecting;
        },
        set: function (ev) {
            var _this = this;
            if (this._calloutSeriesSelecting_wrapped !== null) {
                this.i.calloutSeriesSelecting = delegateRemove(this.i.calloutSeriesSelecting, this._calloutSeriesSelecting_wrapped);
                this._calloutSeriesSelecting_wrapped = null;
                this._calloutSeriesSelecting = null;
            }
            this._calloutSeriesSelecting = ev;
            this._calloutSeriesSelecting_wrapped = function (o, e) {
                var outerArgs = new IgrCalloutSeriesSelectingEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeCalloutSeriesSelecting) {
                    _this.beforeCalloutSeriesSelecting(_this, outerArgs);
                }
                if (_this._calloutSeriesSelecting) {
                    _this._calloutSeriesSelecting(_this, outerArgs);
                }
            };
            this.i.calloutSeriesSelecting = delegateCombine(this.i.calloutSeriesSelecting, this._calloutSeriesSelecting_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    return IgrCalloutLayer;
}(IgrAnnotationLayer));
export { IgrCalloutLayer };
